import React from 'react'
import createCache from '@emotion/cache'
import { emotionReact } from './externals/clientBundleExternals'
import { ProviderFactories, emotionCacheKey } from './utils/uiProvidersApi'

export const emotionApi = () => {
	const muiCache = createCache({ key: emotionCacheKey })
	const withProvider = (Comp: React.ComponentType) => (props: any) => (
		<emotionReact.CacheProvider value={muiCache}>
			<Comp {...props} />
		</emotionReact.CacheProvider>
	)
	return {
		withProvider,
		// TODO: remove when types are separated for ssr + client
		extractCss: () => '',
	}
}

// This type is partial because we don't need a client-side implementation for some libraries
export const providerApiFactories: Pick<ProviderFactories, 'mui'> = {
	mui: emotionApi,
}
